import { isEmpty } from '@/common/validators';

const initialData = {
  tags: null,
  exkey: null
};

export default {
  namespaced: true,
  state: {
    tags: initialData.tags,
    exkey: initialData.exkey
  },
  getters: {
    tags(state) {
      return state.tags;
    },
    exkey(state) {
      return state.exkey;
    }
  },
  actions: {
    /**
     * 追加情報の設定
     */
    setAddInfo({ commit }, addInfo) {
      commit('setAddInfo', addInfo);
    },
    /**
     * 追加情報の初期化
     */
    clearAddInfo({ commit }) {
      commit('clearAddInfo', initialData);
    }
  },
  mutations: {
    setAddInfo(state, addInfo) {
      if (isEmpty(addInfo)) {
        return;
      }
      if ('tags' in addInfo) {
        state.tags = addInfo.tags;
      }
      if ('exkey' in addInfo) {
        state.exkey = addInfo.exkey;
      }
    },
    clearAddInfo(state, initialData) {
      for (let key in initialData) {
        state[key] = initialData[key];
      }
    }
  }
};
